import { createSelector } from '@reduxjs/toolkit';
import { selectRebalance } from '../selectors';

export const selectRebalanceId = createSelector(selectRebalance, (common) => common.rebalanceId);

export const selectValidationWarnings = createSelector(selectRebalance, (common) => common.validationWarnings);
